var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 546.8 546.8",
    style: {
      enableBackground: "new 0 0 546.8 546.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E0E0E0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.5,273.4c0,30.5-16.4,57.1-40.9,71.6l96.1,164.5c14.6-8.5,28.3-18.3,40.9-29.3 c14.4-12.8,27.6-27,40.5-43.6c34-45.6,54.1-102,54.1-163.2H356.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "wheel-spacer",
    x: 273.7,
    y: 546.7,
    className: "st0",
    width: 0.1,
    height: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.4,190.3c14.5,0,28.1,3.7,40,10.2l92.7-166.1C366.7,12.5,321.4,0,273.1,0c-50.9,0-98.6,13.9-139.5,38.2 l97.2,163.9C243.3,194.6,257.8,190.3,273.4,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.3,273.4H-0.3c0,61.2,20.1,117.6,54.1,163.2c12.9,16.6,26.1,30.8,40.5,43.6c12.6,11,26.3,20.8,40.9,29.3 L231.3,345C206.8,330.5,190.3,303.9,190.3,273.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.a2e24573e232937be9d4cf6428273b42.svg";
export { ForwardRef as ReactComponent };